import {isNumber} from "utils/IsNumber.js"


const shuffle = (pad, ... args) => {
    // we want to rearrage an effect rack deterministically

    let [_from, _to] = args;

    let rack = pad.effectRack;
    let effects = [... rack.effects];
    effects.sort((a,b) => a.id.localeCompare(b.id));

    let toEffect = effects[_to];
    let fromEffect = effects[_from];

    if (!toEffect || !fromEffect || toEffect === fromEffect) {
        return;
    }

    let toEffect_outbound = getOutbound(rack, toEffect);
    let toEffect_inbound = getInbound(rack, toEffect);

    let fromEffect_outbound = getOutbound(rack, fromEffect);
    let fromEffect_inbound = getInbound(rack, fromEffect);
    
    // first delete the edges 

    let allEdges = [... toEffect_outbound, ... toEffect_inbound, ...fromEffect_outbound, ...fromEffect_inbound];
    allEdges.forEach(
        ({edge}) => {
            rack.deleteEdge(edge);
        });

    for (let inbound of toEffect_inbound) {
        let effect = inbound.effect;
        if (inbound.effect === fromEffect) {
            effect = toEffect;
        }
        if (effect !== fromEffect) {
            rack.connectNodes(effect, fromEffect);
        }
    }

    for (let inbound of fromEffect_inbound) {
        let effect = inbound.effect;
        if (inbound.effect === toEffect) {
            effect = fromEffect;
        }
        if (effect !== toEffect) {
            rack.connectNodes(effect, toEffect);
        }
    }

    for (let outbound of toEffect_outbound) {
        let effect = outbound.effect;
        if (outbound.effect === fromEffect) {
            effect = toEffect;
        }
        rack.connectNodes(fromEffect, effect);
    }

    for (let outbound of fromEffect_outbound) {
        let effect = outbound.effect;
        if (outbound.effect === toEffect) {
            effect = fromEffect;
        }
        rack.connectNodes(toEffect, effect);
    }
};


const getOutbound = (rack, effect) => {
    let adj = rack.adjacencyLists;
    let edges = adj[effect.id];
    return edges.map(edge => ({
        edge,
        effect: edge.effect
    }));
};

const getInbound = (rack, effect) => {
    // go thru
    let adj = rack.adjacencyLists;
    let list = [];
    for (let id in adj) {
         let edges = adj[id].filter(e => e.effect === effect);
        edges.forEach(edge => {
            let _fx = id === "-1" ? rack.inputNode : id === "-2" ? rack.outputNode :
                rack.effects.find(e => e.id === id);
            list.push(
                {
                    effect: _fx,
                    edge
                });
        });
    };
    return list;
};

export const effectOperations = {
    shuffle
};
